export default __webpack_public_path__ + "static/media/grid-icon.effb0fbd.svg";